/* MUV native wishlist — no app, no monthly cost. Stores product handles in
   localStorage. Hearts toggle on product cards/PDP; the wishlist page renders
   the saved products by fetching each product's JSON. Works without login.
   (Cross-device account sync is not possible natively with hosted New Customer
   Accounts — that would need an app.) */
(function () {
  'use strict';
  var KEY = 'muv_wishlist';

  var HEART = '<svg class="icon icon-heart" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 20.25l-1.31-1.19C6.05 14.86 3 12.08 3 8.69 3 6.01 5.1 4 7.7 4c1.54 0 3.02.72 3.97 1.86l.33.4.33-.4A5.13 5.13 0 0 1 16.3 4C18.9 4 21 6.01 21 8.69c0 3.39-3.05 6.17-7.69 10.38L12 20.25z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  // Entries are a product handle or, for native colour variants,
  // "handle?variant=ID" so the saved colour is kept.
  function parseEntry(entry) {
    var m = String(entry || '').match(/^([^?]+)(?:\?variant=(\d+))?$/);
    return m ? { handle: m[1], variantId: m[2] || null } : { handle: String(entry || ''), variantId: null };
  }
  function pickVariant(p, variantId) {
    var variants = (p && p.variants) || [];
    if (variantId) {
      var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (v) return v;
    }
    return null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; // true if now added
  }

  // ---- Marking hearts active/inactive ----
  function markHearts(root) {
    var list = read();
    (root || document).querySelectorAll('.muv-wishlist-toggle[data-wishlist-handle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-wishlist-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // ---- Header count ----
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('.muv-wishlist-count').forEach(function (el) {
      el.textContent = '(' + n + ')'; // mismo formato que el contador del carrito "(N)"
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // ---- Price formatting (match the no-decimals, Spain-style site prices) ----
  function formatMoney(cents) {
    // Store money format is `amount_no_decimals_with_comma_separator` → no
    // decimals, dot as thousands separator (532,40 → "532 €", 1899 → "1.899 €").
    // Done manually because Intl es-ES doesn't group 4-digit numbers the same way.
    var value = Math.round((cents || 0) / 100);
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  // ---- Storefront root (respects the /es/ market prefix) ----
  function rootPath() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base;
  }

  // ---- Short description, same as the collection cards (strip HTML, ~80 chars) ----
  function shortDesc(html) {
    if (!html) return '';
    var txt = String(html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (txt.length > 80) txt = txt.slice(0, 80).replace(/\s+\S*$/, '') + '…';
    return txt;
  }

  // ---- Lightweight toast ----
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'muv-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    // force reflow so the transition replays if it's already visible
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  // ---- Toolbar product count ("3 productos") ----
  function updateToolbarCount(n) {
    var el = document.querySelector('[data-wishlist-count-text]');
    if (!el) return;
    var one = el.getAttribute('data-unit-one') || 'product';
    var other = el.getAttribute('data-unit-other') || 'products';
    el.textContent = n + ' ' + (n === 1 ? one : other);
  }

  // ---- Share: encode the saved handles into a link anyone can open ----
  function shareWishlist(btn) {
    var list = read();
    if (!list.length) return;
    var url = location.origin + location.pathname + '?items=' + list.map(encodeURIComponent).join(',');
    var copied = (btn && btn.getAttribute('data-copied')) || 'Link copied';
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { toast(copied); }).catch(function () { window.prompt('', url); });
    } else {
      window.prompt('', url);
    }
  }

  // ---- When the page is opened from a shared link, merge those items in ----
  function loadSharedFromUrl() {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(location.search);
    var shared = params.get('items');
    if (!shared) return;
    var incoming = shared.split(',').map(function (s) { return decodeURIComponent(s.trim()); }).filter(Boolean);
    if (!incoming.length) return;
    var list = read(), added = 0;
    incoming.forEach(function (h) { if (list.indexOf(h) === -1) { list.push(h); added++; } });
    if (added) write(list);
    params.delete('items'); // strip so a refresh doesn't re-process it
    var clean = location.pathname + (params.toString() ? ('?' + params.toString()) : '') + location.hash;
    if (window.history && history.replaceState) history.replaceState(null, '', clean);
  }

  // ---- Add every saved (purchasable) product to the cart at once ----
  function addAllToCart(btn) {
    var list = read();
    if (!list.length) return;
    var base = rootPath();
    btn.disabled = true;
    Promise.all(list.map(function (h) {
      return fetch(base + 'products/' + parseEntry(h).handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var items = [], skipped = 0;
      products.forEach(function (p, i) {
        if (!p) { skipped++; return; }
        var saved = pickVariant(p, parseEntry(list[i]).variantId);
        var v = saved && saved.available && saved.price > 0 ? saved : (p.variants || []).filter(function (x) { return x.available && x.price > 0; })[0];
        if (v) { items.push({ id: v.id, quantity: 1 }); } else { skipped++; }
      });
      if (!items.length) {
        btn.disabled = false;
        toast(btn.getAttribute('data-msg-none') || 'No products available');
        return;
      }
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
      }
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (resp) {
        var msg = (btn.getAttribute('data-msg-added') || '{n} added').replace('{n}', items.length);
        if (skipped) msg += ' · ' + (btn.getAttribute('data-msg-skipped') || '{n} skipped').replace('{n}', skipped);
        toast(msg);
        btn.disabled = false;
        // Refresh the cart drawer + header bubble and open the drawer. Done
        // manually (not cart.renderContents) because the theme's version throws
        // on a multi-item add: the response has no top-level `id`, so its
        // notification block queries a null .cart-item and crashes before opening.
        if (cart && resp && resp.sections) { applyCartSections(resp, cart); }
        else { refreshCartCount(base); }
      }).catch(function () { btn.disabled = false; });
    });
  }

  function refreshCartCount(base) {
    fetch(base + 'cart.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
      if (!c) return;
      document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
        var span = el.querySelector('span[aria-hidden]') || el;
        span.textContent = '(' + c.item_count + ')';
      });
    }).catch(function () {});
  }

  // Swap the cart drawer + header bubble HTML from the add response's sections,
  // then open the drawer. Reuses the theme's own (non-fragile) section helpers.
  function applyCartSections(resp, cart) {
    try {
      cart.getSectionsToRender().forEach(function (section) {
        var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        var html = resp.sections[section.id];
        if (el && html != null && typeof cart.getSectionInnerHTML === 'function') {
          el.innerHTML = cart.getSectionInnerHTML(html, section.selector);
        }
      });
      var inner = cart.querySelector('.drawer__inner');
      if (inner) { inner.classList.remove('is-empty'); }
      if (typeof cart.open === 'function') { cart.open(); }
    } catch (e) {}
  }

  // ---- Recommendations ("También te puede gustar"). Seeded by the first saved
  //      item via Shopify's engine; tops up / falls back to the catalogue so the
  //      row is full even when the wishlist is EMPTY (so people start adding). ----
  var recosState = { key: null };
  function recoCard(p, addLabel) {
    var img = p.featured_image
      ? (String(p.featured_image).indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image)
      : '';
    var imgTag = img ? '<img src="' + img + '&width=600" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var price = (typeof p.price === 'number') ? formatMoney(p.price) : esc(p.price || '');
    var desc = shortDesc(p.description);
    return '' +
      '<div class="muv-reco-card" data-product="' + esc(p.handle) + '">' +
        '<a class="muv-reco-card__media" href="' + esc(p.url) + '">' + imgTag + '</a>' +
        '<button type="button" class="muv-wishlist-toggle muv-reco-card__heart" data-wishlist-handle="' + esc(p.handle) + '" aria-pressed="false" aria-label="' + esc(addLabel || '') + '">' + HEART + '</button>' +
        '<a class="muv-reco-card__info" href="' + esc(p.url) + '">' +
          '<span class="muv-reco-card__top">' +
            '<span class="muv-reco-card__title">' + esc(p.title) + '</span>' +
            '<span class="muv-reco-card__price">' + price + '</span>' +
          '</span>' +
          (desc ? '<span class="muv-reco-card__desc">' + esc(desc) + '</span>' : '') +
        '</a>' +
      '</div>';
  }
  function renderRecommendations(list) {
    var wrap = document.querySelector('[data-wishlist-recos]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-wishlist-recos-grid]');
    if (!grid) return;
    var exclude = (list || []).map(function (e) { return parseEntry(e).handle; });
    var key = exclude.join('|');
    if (recosState.key === key && grid.children.length) { wrap.hidden = false; return; }
    recosState.key = key;
    var base = rootPath();
    var WANT = 8;
    var addLabel = grid.getAttribute('data-add-label') || '';

    function normalizeCatalog(p) {
      var cents = (p.variants && p.variants[0]) ? Math.round(parseFloat(p.variants[0].price) * 100) : 0;
      return {
        handle: p.handle,
        title: p.title,
        url: base + 'products/' + p.handle,
        featured_image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
        price: cents,
        description: p.body_html || ''
      };
    }
    // Render up to WANT products, deduped, excluding the wishlist and anything
    // without a real price (the catalogue still has 0 € drafts pre-launch).
    function finish(prods) {
      var seen = {};
      prods = prods.filter(function (p) {
        if (!p || !p.handle || exclude.indexOf(p.handle) !== -1 || seen[p.handle]) return false;
        if (!(p.price > 0)) return false;
        seen[p.handle] = 1; return true;
      }).slice(0, WANT);
      if (!prods.length) { wrap.hidden = true; return; }
      grid.innerHTML = prods.map(function (p) { return recoCard(p, addLabel); }).join('');
      wrap.hidden = false;
      markHearts(grid);
    }
    function catalogFill(existing) {
      var seen = exclude.concat((existing || []).map(function (p) { return p.handle; }));
      return fetch(base + 'collections/all/products.json?limit=40')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var fill = ((d && d.products) || []).filter(function (p) { return seen.indexOf(p.handle) === -1; }).map(normalizeCatalog);
          finish((existing || []).concat(fill));
        })
        .catch(function () { finish(existing || []); });
    }

    // Empty wishlist → just catalogue products so people can start adding.
    if (!exclude.length) { catalogFill([]); return; }

    // Otherwise: Shopify recommendations seeded by the first saved item, topped
    // up with catalogue products (the engine is thin pre-launch, no traffic yet).
    fetch(base + 'products/' + exclude[0] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sp) {
        if (!sp) return [];
        return fetch(base + 'recommendations/products.json?product_id=' + sp.id + '&limit=10&intent=related')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { return ((d && d.products) || []); });
      })
      .then(function (recs) {
        if (recs.length >= WANT) { finish(recs); return; }
        catalogFill(recs);
      })
      .catch(function () { wrap.hidden = true; });
  }

  // ---- Wishlist page rendering ----
  function renderWishlistPage() {
    var grid = document.querySelector('.muv-wishlist-grid');
    if (!grid) return;
    var empty = document.querySelector('.muv-wishlist-empty');
    var toolbar = document.querySelector('[data-wishlist-toolbar]');
    var list = read();

    updateToolbarCount(list.length);
    // Recommendations show in BOTH states: with saved items (related) and when
    // empty (catalogue) so a new visitor has products to start adding.
    renderRecommendations(list);

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (toolbar) toolbar.hidden = false;
    grid.setAttribute('aria-busy', 'true');

    Promise.all(list.map(function (entry) {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (base.charAt(base.length - 1) !== '/') base += '/';
      return fetch(base + 'products/' + parseEntry(entry).handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = products.map(function (p, i) {
        if (!p) return '';
        var entry = list[i];
        var v = pickVariant(p, parseEntry(entry).variantId);
        // Con variantes de color, el título lleva el color para distinguirlas.
        var colorIndex = (p.options || []).findIndex(function (o) {
          var name = String((o && o.name) || o).toLowerCase();
          return name === 'color' || name === 'colour';
        });
        var variantLabel = v && colorIndex !== -1 && v.options ? v.options[colorIndex] : '';
        var cardTitle = variantLabel ? p.title + ' · ' + variantLabel : p.title;
        var url = v ? p.url + '?variant=' + v.id : p.url;
        var price = v ? v.price : p.price;
        var imgSrc = (v && v.featured_image && v.featured_image.src) || p.featured_image;
        var img = imgSrc ? (imgSrc.indexOf('//') === 0 ? 'https:' + imgSrc : imgSrc) : '';
        var imgTag = img
          ? '<img src="' + img + '&width=600" alt="' + esc(p.title) + '" loading="lazy">'
          : '';
        return '' +
          '<div class="muv-wishlist-card" data-product="' + esc(p.handle) + '">' +
            '<a class="muv-wishlist-card__media" href="' + esc(url) + '">' + imgTag + '</a>' +
            '<button type="button" class="muv-wishlist-toggle muv-wishlist-card__remove is-active" data-wishlist-handle="' + esc(entry) + '" aria-pressed="true" aria-label="' + esc(grid.getAttribute('data-remove-label') || 'Remove') + '">' + HEART + '</button>' +
            '<div class="muv-wishlist-card__info">' +
              '<div class="muv-wishlist-card__top">' +
                '<a class="muv-wishlist-card__title" href="' + esc(url) + '">' + esc(cardTitle) + '</a>' +
                '<span class="muv-wishlist-card__price">' + formatMoney(price) + '</span>' +
              '</div>' +
              (shortDesc(p.description) ? '<p class="muv-wishlist-card__desc">' + esc(shortDesc(p.description)) + '</p>' : '') +
            '</div>' +
          '</div>';
      }).join('');
      grid.removeAttribute('aria-busy');
      // Re-render lost some handles (deleted products)? prune them.
      var live = list.filter(function (entry, i) { return !!products[i]; });
      if (live.length !== list.length) { write(live); updateCount(); }
      if (empty && !live.length) empty.hidden = false;
    });
  }

  // ---- Click handling (delegated, works for dynamically-added cards) ----
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var shareBtn = e.target.closest('[data-wishlist-share]');
    if (shareBtn) { e.preventDefault(); shareWishlist(shareBtn); return; }
    var addAllBtn = e.target.closest('[data-wishlist-add-all]');
    if (addAllBtn) { e.preventDefault(); addAllToCart(addAllBtn); return; }
    var btn = e.target.closest('.muv-wishlist-toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    toggle(handle);
    markHearts();
    updateCount();
    var onWishlistPage = !!document.querySelector('.muv-wishlist-grid');
    var card = btn.closest('.muv-wishlist-card');
    if (card) {
      // Removed from the grid: drop it instantly. If the list is now empty,
      // re-render to swap in the empty state; otherwise refresh the count + recos
      // (the removed item may now belong in the recommendations).
      card.remove();
      if (!read().length) { renderWishlistPage(); }
      else { updateToolbarCount(read().length); renderRecommendations(read()); }
    } else if (onWishlistPage) {
      // Toggled from a recommendation card → it was just added; re-render so it
      // appears in the grid (and drops out of the recommendations row).
      renderWishlistPage();
    }
  });

  // ---- Cross-tab sync ----
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { markHearts(); updateCount(); renderWishlistPage(); }
  });

  window.muvWishlistRefresh = function () { markHearts(); };

  function init() {
    loadSharedFromUrl();
    markHearts();
    updateCount();
    renderWishlistPage();
    // Página con contenedor de recomendaciones pero SIN grid de wishlist (p.ej. la
    // 404): mostramos "también te puede gustar" — relacionados con lo guardado o,
    // si no hay nada guardado, productos del catálogo.
    if (!document.querySelector('.muv-wishlist-grid') && document.querySelector('[data-wishlist-recos]')) {
      renderRecommendations(read());
    }
    // Re-mark hearts when new product cards are injected (AJAX filtering, etc.)
    var grids = document.querySelector('main') || document.body;
    if (window.MutationObserver && grids) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { markHearts(); break; }
        }
      });
      mo.observe(grids, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { markHearts(); updateCount(); renderWishlistPage(); });
})();
